import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import reporting_body from '../../static/images_ae/reporting/reporting_body.png';
import area_head from '../../static/images_ae/reporting/area_head.png';
import line_head from '../../static/images_ae/reporting/line_head.png';
import area_chest from '../../static/images_ae/reporting/area_chest.png';
import line_chest from '../../static/images_ae/reporting/line_chest.png';
import area_stomach from '../../static/images_ae/reporting/area_stomach.png';
import line_stomach from '../../static/images_ae/reporting/line_stomach.png';
import area_others from '../../static/images_ae/reporting/area_others.png';
import line_others from '../../static/images_ae/reporting/line_others.png';
import area_four_limbs from '../../static/images_ae/reporting/area_four_limbs.png';
import line_four_limbs from '../../static/images_ae/reporting/line_four_limbs.png';
import tip_top_select from '../../static/images_ae/reporting/tip_top_select.png';
import tip_bottom_select from '../../static/images_ae/reporting/tip_bottom_select.png';
import Chest from './chest';
import Head from './head';
import FourLimbs from './fourLimbs';
import Others from './others';
import Stomach from './stomach';
import Completed from './completed';
import Result from './result';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';

const api = new ApiCore();

const AeReporting = (props: any) => {

    const [headSelected, setHeadSelected] = useState<any>(false);
    const [chestSelected, setChestSelected] = useState<any>(false);
    const [stomachSelected, setStomachSelect] = useState<any>(false);
    const [othersSelected, setOthersSelected] = useState<any>(false);
    const [fourLimbsSelected, setFourLimbsSelected] = useState<any>(false);
    const [chestOrgans, setChestOrgans] = useState<any>([]);
    const [stomachOrgans, setStomachOrgans] = useState<any>([]);
    const [headOrgans, setHeadOrgans] = useState<any>([]);
    const [limbsOrgans, setLimbsOrgans] = useState<any>([]);
    const [othersOrgans, setOthersOrgans] = useState<any>([]);
    const [treatments, setTreatmentsList] = useState<any>([]);
    const [showBody, setShowBody] = useState<any>(true);
    const [showHead, setShowHead] = useState<any>(false);
    const [showChest, setShowChest] = useState<any>(false);
    const [showStomach, setShowStomach] = useState<any>(false);
    const [showLimbs, setShowLimbs] = useState<any>(false);
    const [showOthers, setShowOthers] = useState<any>(false);
    const [showCompleted, setShowCompleted] = useState<any>(false);
    const [showResult, setShowResult] = useState<any>(false);
    const [headSelectCount, setHeadSelectCount] = useState<number>(0);
    const [chestSelectCount, setChestSelectCount] = useState<number>(0);
    const [stomachSelectCount, setStomachSelectCount] = useState<number>(0);
    const [othersSelectCount, setOthersSelectCount] = useState<number>(0);
    const [limbsSelectCount, setLimbsSelectCount] = useState<number>(0);
    const [selectedCount, setSelectedCount] = useState<number>(0);
    const [symptomsResult, setSymptomsResult] = useState<any>([]);

    useEffect(() => {
        window.document.title = 'ALK风险评估';
        initData();
        return () => {
            window.removeEventListener('popstate', onPopState);
        }
    }, [])

    useEffect(() => {
        // let _selectedCount = 0;
        // [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected].forEach((val: any) => {
        //     if (val) {
        //         _selectedCount++;
        //     }
        // })
        // setSelectedCount(_selectedCount);
    }, [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected])

    useEffect(() => {
        let _selectedCount = 0;
        [headSelectCount, chestSelectCount, stomachSelectCount, othersSelectCount, limbsSelectCount].forEach((val: any) => {
            if (val) {
                _selectedCount += val;
            }
        })
        setSelectedCount(_selectedCount);
    }, [headSelectCount, chestSelectCount, stomachSelectCount, othersSelectCount, limbsSelectCount])

    useEffect(() => {
        const _showBody = [showHead, showChest, showStomach, showLimbs, showOthers, showCompleted, showResult].every((val: any) => !val)
        setShowBody(_showBody);
    }, [showHead, showChest, showStomach, showLimbs, showOthers, showCompleted, showResult])

    const initData = () => {
        window.addEventListener('popstate', onPopState)
        api.getEvaluationConfig().then((res: any) => {
            if (res.code == 0) {
                setTreatmentsList(res.data?.treatments || []);
                const _position = res.data?.positions || [];
                _position.forEach((val: any) => {
                    if (val.type == 'chest') {
                        setChestOrgans(val);
                    } else if (val.type == 'abdomen') {
                        setStomachOrgans(val);
                    } else if (val.type == 'head') {
                        setHeadOrgans(val);
                    } else if (val.type == 'limbs') {
                        setLimbsOrgans(val);
                    } else if (val.type == 'other') {
                        setOthersOrgans(val);
                    }
                });

            }
        })
    }

    const onPopState = (event: any) => {
    }

    const headSelect = () => {
        // setHeadSelected(!headSelected);
        window.history.pushState({}, document.title, '#/ae/reporting');
        setShowHead(true);
    }

    const chestSelect = () => {
        // setChestSelected(!chestSelected);
        window.history.pushState({}, document.title, '#/ae/reporting');
        setShowChest(true);
    }

    const stomachSelect = () => {
        // setStomachSelect(!stomachSelected);
        window.history.pushState({}, document.title, '#/ae/reporting');
        setShowStomach(true);
    }

    const othersSelect = () => {
        // setOthersSelected(!othersSelected);
        window.history.pushState({}, document.title, '#/ae/reporting');
        setShowOthers(true);
    }

    const fourLimbsSelect = () => {
        // setFourLimbsSelected(!fourLimbsSelected);
        window.history.pushState({}, document.title, '#/ae/reporting');
        setShowLimbs(true);
    }

    const onBack = () => {
        setShowHead(false);
        setShowChest(false);
        setShowStomach(false);
        setShowOthers(false);
        setShowLimbs(false);
        setShowCompleted(false);
        setShowResult(false);
        // props.history.go(-1);
    }

    const onComplete = (type: string, organList: any) => {
        if (type == 'head') {
            const _headOrgans = headOrgans;
            _headOrgans.organs = organList;
            setHeadOrgans(_headOrgans);
            let _count = 0;
            _headOrgans.organs.forEach((val: any) => {
                val.symptoms.forEach((v: any) => {
                    if (v.selected) {
                        _count++;
                    }
                })
            })
            setHeadSelectCount(_count);
            onBack();
        } else if (type == 'chest') {
            const _chestOrgans = chestOrgans;
            _chestOrgans.organs = organList;
            setChestOrgans(_chestOrgans);
            let _count = 0;
            _chestOrgans.organs.forEach((val: any) => {
                val.symptoms.forEach((v: any) => {
                    if (v.selected) {
                        _count++;
                    }
                })
            })
            setChestSelectCount(_count);
            onBack();
        } else if (type == 'abdomen') {
            const _stomachOrgans = stomachOrgans;
            _stomachOrgans.organs = organList;
            setStomachOrgans(_stomachOrgans);
            let _count = 0;
            _stomachOrgans.organs.forEach((val: any) => {
                val.symptoms.forEach((v: any) => {
                    if (v.selected) {
                        _count++;
                    }
                })
            })
            setStomachSelectCount(_count);
            onBack();
        } else if (type == 'other') {
            const _othersOrgans = othersOrgans;
            _othersOrgans.organs = organList;
            setOthersOrgans(_othersOrgans);
            let _count = 0;
            _othersOrgans.organs.forEach((val: any) => {
                val.symptoms.forEach((v: any) => {
                    if (v.selected) {
                        _count++;
                    }
                })
            })
            setOthersSelectCount(_count);
            onBack();
        } else if (type == 'limbs') {
            const _limbsOrgans = limbsOrgans;
            _limbsOrgans.organs = organList;
            setLimbsOrgans(_limbsOrgans);
            let _count = 0;
            _limbsOrgans.organs.forEach((val: any) => {
                val.symptoms.forEach((v: any) => {
                    if (v.selected) {
                        _count++;
                    }
                })
            })
            setLimbsSelectCount(_count);
            onBack();
        }
    }

    const toComplete = () => {
        if (selectedCount > 0) {
            setShowBody(false);
            setShowCompleted(true);
            window.history.pushState({}, document.title, '#/ae/reporting');
        }
    }

    const onCompletedFinished = (data: any) => {
        setSymptomsResult(data || {});
        setShowCompleted(false);
        setShowBody(false);
        setShowResult(true);
    }

    return (
        <div className={styles.ae_reporting}>
            {
                showBody &&
                <div className={styles.ae_reporting_content}>
                    <div className={styles.tip_top_wrap}>
                        <img className={styles.tip_top} src={tip_top_select} alt="" />
                        <div className={styles.tip_top_text}>请从下列5个部位中选择您出现不适的部位</div>
                    </div>
                    <div className={styles.area_body_container}>
                        <img className={styles.area_body} src={reporting_body} alt="" />
                        <div className={`${styles.area_base} ${styles.area_head} ${headSelectCount > 0 ? styles.area_active : ''}`} onClick={ () => { headSelect()} }>
                            <div className={`${styles.area_tl_l}`}></div>
                            <div className={`${styles.area_tl_t}`}></div>
                            <div className={`${styles.area_tr_r}`}></div>
                            <div className={`${styles.area_tr_t}`}></div>
                            <div className={`${styles.area_bl_l}`}></div>
                            <div className={`${styles.area_bl_b}`}></div>
                            <div className={`${styles.area_br_r}`}></div>
                            <div className={`${styles.area_br_b}`}></div>
                            <div className={styles.area_head_top}>
                                <img className={styles.icon_head} src={area_head} alt="" />
                                <span>头部</span>
                                {
                                    headSelectCount > 0 &&
                                    <div className={styles.symptom}>{headSelectCount}个症状</div>
                                }
                            </div>
                            <div className={styles.area_head_middle}>
                            </div>
                            <div className={styles.area_head_bottom}>
                                包括精神方面、五官等部位
                            </div>
                            <img  className={styles.line_head} src={line_head} alt="" />
                        </div>
                        <div className={`${styles.area_base} ${styles.area_chest} ${chestSelectCount > 0 ? styles.area_active : ''}`} onClick={ () => { chestSelect()} }>
                            <div className={`${styles.area_tl_l}`}></div>
                            <div className={`${styles.area_tl_t}`}></div>
                            <div className={`${styles.area_tr_r}`}></div>
                            <div className={`${styles.area_tr_t}`}></div>
                            <div className={`${styles.area_bl_l}`}></div>
                            <div className={`${styles.area_bl_b}`}></div>
                            <div className={`${styles.area_br_r}`}></div>
                            <div className={`${styles.area_br_b}`}></div>
                            <div className={styles.area_head_top}>
                                <img className={styles.icon_head} src={area_chest} alt="" />
                                <span>胸部</span>
                                {
                                    chestSelectCount > 0 &&
                                    <div className={styles.symptom}>{chestSelectCount}个症状</div>
                                }
                            </div>
                            <div className={styles.area_head_middle}>
                            </div>
                            <div className={styles.area_head_bottom}>
                                包括心脏、肺部等器官
                            </div>
                            <img  className={styles.line_chest} src={line_chest} alt="" />
                        </div>
                        <div className={`${styles.area_base} ${styles.area_stomach} ${stomachSelectCount > 0 ? styles.area_active : ''}`} onClick={ () => { stomachSelect()} }>
                            <div className={`${styles.area_tl_l}`}></div>
                            <div className={`${styles.area_tl_t}`}></div>
                            <div className={`${styles.area_tr_r}`}></div>
                            <div className={`${styles.area_tr_t}`}></div>
                            <div className={`${styles.area_bl_l}`}></div>
                            <div className={`${styles.area_bl_b}`}></div>
                            <div className={`${styles.area_br_r}`}></div>
                            <div className={`${styles.area_br_b}`}></div>
                            <div className={styles.area_head_top}>
                                <img className={styles.icon_head} src={area_stomach} alt="" />
                                <span>腹部</span>
                                {
                                    stomachSelectCount > 0 &&
                                    <div className={styles.symptom}>{stomachSelectCount}个症状</div>
                                }
                            </div>
                            <div className={styles.area_head_middle}>
                            </div>
                            <div className={styles.area_head_bottom}>
                                包括肝脏、肠胃肾脏等器官
                            </div>
                            <img  className={styles.line_stomach} src={line_stomach} alt="" />
                        </div>
                        <div className={`${styles.area_base} ${styles.area_others} ${othersSelectCount > 0 ? styles.area_active : ''}`} onClick={ () => { othersSelect()} }>
                            <div className={`${styles.area_tl_l}`}></div>
                            <div className={`${styles.area_tl_t}`}></div>
                            <div className={`${styles.area_tr_r}`}></div>
                            <div className={`${styles.area_tr_t}`}></div>
                            <div className={`${styles.area_bl_l}`}></div>
                            <div className={`${styles.area_bl_b}`}></div>
                            <div className={`${styles.area_br_r}`}></div>
                            <div className={`${styles.area_br_b}`}></div>
                            <div className={styles.area_head_top}>
                                <img className={styles.icon_head} src={area_others} alt="" />
                                <span>其他</span>
                                {
                                    othersSelectCount > 0 &&
                                    <div className={styles.symptom}>{othersSelectCount}个症状</div>
                                }
                            </div>
                            <div className={styles.area_head_middle}>
                            </div>
                            <div className={styles.area_head_bottom}>
                                包括体重、皮肤、骨骼肌肉和血液相关症状等
                            </div>
                            <img  className={styles.line_others} src={line_others} alt="" />
                        </div>
                        <div className={`${styles.area_base} ${styles.area_four_limbs} ${limbsSelectCount > 0 ? styles.area_active : ''}`} onClick={ () => { fourLimbsSelect()} }>
                            <div className={`${styles.area_tl_l}`}></div>
                            <div className={`${styles.area_tl_t}`}></div>
                            <div className={`${styles.area_tr_r}`}></div>
                            <div className={`${styles.area_tr_t}`}></div>
                            <div className={`${styles.area_bl_l}`}></div>
                            <div className={`${styles.area_bl_b}`}></div>
                            <div className={`${styles.area_br_r}`}></div>
                            <div className={`${styles.area_br_b}`}></div>
                            <div className={styles.area_head_top}>
                                <img className={styles.icon_head} src={area_four_limbs} alt="" />
                                <span>四肢</span>
                                {
                                    limbsSelectCount > 0 &&
                                    <div className={styles.symptom}>{limbsSelectCount}个症状</div>
                                }
                            </div>
                            <div className={styles.area_head_middle}>
                            </div>
                            <div className={styles.area_head_bottom}>
                                包括手足的不适和神经疼痛等
                            </div>
                            <img className={styles.line_four_limbs} src={line_four_limbs} alt="" />
                        </div>
                    </div>
                    <div className={styles.tip_bottom_wrap} onClick={toComplete}>
                        <img className={styles.bootom_top} src={tip_bottom_select} alt="" />
                        <div className={styles.bootom_top_text}>{
                        selectedCount == 0
                        ?
                        '请先选择症状后再进行下一步'
                        :
                        `已选择${selectedCount}个症状、进入下一步`
                        }</div>
                    </div>
                </div>
            }
            {
                showHead &&
                <Head organs={headOrgans} onBack={onBack} onComplete={onComplete} />
            }
            {
                showChest &&
                <Chest organs={chestOrgans} onBack={onBack} onComplete={onComplete} />
            }
            {
                showStomach &&
                <Stomach organs={stomachOrgans} onBack={onBack} onComplete={onComplete} />
            }
            {
                showLimbs &&
                <FourLimbs organs={limbsOrgans} onBack={onBack} onComplete={onComplete} />
            }
            {
                showOthers &&
                <Others organs={othersOrgans} onBack={onBack} onComplete={onComplete} />
            }
            {
                showCompleted &&
                <Completed 
                    treatments={treatments}
                    headOrgans={headOrgans}
                    chestOrgans={chestOrgans}
                    stomachOrgans={stomachOrgans}
                    limbsOrgans={limbsOrgans}
                    othersOrgans={othersOrgans}
                    onBack={onBack}
                    onCompletedFinished={onCompletedFinished}
                />
            }
            {
                showResult &&
                <Result 
                    symptomsResult={symptomsResult}
                    onBack={onBack}
                />
            }
        </div>
    )
}

export default withRouter(AeReporting);